import { z } from "zod";

export const GlobalMailInputSchema = z.object({
  Title: z.string().min(1),
  Subject: z.string().min(1),
  Body: z.string().min(1),
  GroupIds: z.array(z.number()).optional(),

  Attachments: z
    .array(
      z.object({
        FileName: z.string(),
        Data: z.string(),
      })
    )
    .optional(),
});

export type GlobalMailInput = z.infer<typeof GlobalMailInputSchema>;
